<template>
  <layout-report-step
    :isDone="isDone"
    :title="header.title"
    :description="header.description"
    :image="header.image"
    :debug="header.debug"
  >
    <v-card class="pt-4 pr-4 pl-4" flat max-width="500">
      <v-form ref="form" v-model="valid">
        <v-select
          v-model="tripType"
          :items="tripTypeOptions"
          :rules="requiredRule"
          outlined
          :label="$t('report.tripDetails.purpose')"
          data-test-trip-purpose
        ></v-select>

        <v-radio-group
          :label="$t('report.tripDetails.isValidDriversLicense')"
          v-model="isValidDriversLicense"
          data-test-valid-license
        >
          <v-radio :label="$t('yes')" :value="true" color="primary"></v-radio>
          <v-radio :label="$t('no')" :value="false" color="primary"></v-radio>
        </v-radio-group>

        <v-radio-group
          :label="$t('report.tripDetails.isUnderInfluence')"
          v-model="isUnderInfluence"
          data-test-is-under-influence
        >
          <v-radio :label="$t('yes')" :value="true" color="primary"></v-radio>
          <v-radio :label="$t('no')" :value="false" color="primary"></v-radio>
        </v-radio-group>
      </v-form>
    </v-card>
  </layout-report-step>
</template>

<script lang="ts">
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { TripTypeEnum } from "@/lib/enum/trip-type.enum";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import { requiredRule } from "@/lib/rules/requiredRule";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ReportModule } from "@/store/modules/report.store";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    LayoutReportStep
  }
})
export default class ReportTripDetails extends ReportStepMixin implements IReportStep {
  header: IReportHeaderData = {
    title: "report.tripDetails.title",
    description: "report.tripDetails.description"
  };

  screen = ReportScreenEnum.tripDetails;
  valid = false;

  tripTypeOptions = [
    { text: this.$t(`enums.TripTypeEnum.${TripTypeEnum.BUSINESS}`), value: TripTypeEnum.BUSINESS },
    { text: this.$t(`enums.TripTypeEnum.${TripTypeEnum.PRIVATE}`), value: TripTypeEnum.PRIVATE },
    { text: this.$t(`enums.TripTypeEnum.${TripTypeEnum.COMMUTE}`), value: TripTypeEnum.COMMUTE }
  ];

  get requiredRule() {
    return [requiredRule()];
  }

  get isDone() {
    return (
      this.valid &&
      this.tripType !== undefined &&
      this.isValidDriversLicense !== undefined &&
      this.isUnderInfluence !== undefined
    );
  }

  get tripType(): TripTypeEnum | undefined {
    return ReportModule.tripType;
  }

  set tripType(type: TripTypeEnum | undefined) {
    ReportModule.setTripType(type);
  }

  get isValidDriversLicense(): boolean | undefined {
    return ReportModule.isValidDriversLicense;
  }

  set isValidDriversLicense(value: boolean | undefined) {
    ReportModule.setIsValidDriversLicense(value);
  }

  get isUnderInfluence(): boolean | undefined {
    return ReportModule.isUnderInfluence;
  }

  set isUnderInfluence(value: boolean | undefined) {
    ReportModule.setIsUnderInfluence(value);
  }
}
</script>

<style scoped>
.center {
  text-align: center;
}
</style>
